import { L10n } from '../L10n/L10n';
import { FlowListItemInfo } from '../models/FlowInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Flows } from '../resources/Flows';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { DeleteFlowsActionNotification } from './FlowsActionNotification';

export class DeleteFlowAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'DeleteFlowsActionNotification',
                           'Flows'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private confirmActionDialog: ConfirmActionDialog,
    private deleteFlowsActionNotification: DeleteFlowsActionNotification,
    private flows: Flows) { }

  public showDeleteFlowDialog(
    flows: Set<FlowListItemInfo>,
    dialogScope: ng.IScope): ng.IPromise<any> {

    let dialogBody: string;
    let successMessage: string;

    if (flows.size() === 1) {
      const flow = flows.first();
      dialogBody = this.$translate.instant('confirmDeleteFlow', { FLOW_NAME: L10n.elideIfLong(flow.name) });
      successMessage = this.$translate.instant('flowDeleted', { FLOW_NAME: L10n.elideIfLong(flow.name) });
    } else {
      dialogBody = this.$translate.instant('confirmDeleteFlows', { FLOW_COUNT: flows.size() }, L10n.Interpolations.Count);
      successMessage = this.$translate.instant('flowsDeleted', { FLOW_COUNT: flows.size() }, L10n.Interpolations.Count);
    }

    const dialogInstance = this.confirmActionDialog.open({
      scope: dialogScope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: flows.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: () => this.flows.deleteFlows(flows.keys())
    });

    dialogInstance.result.then((result: IResult) => {
      this.deleteFlowsActionNotification.notify(result, flows);
    });

    return dialogInstance.result;
  }

}

Module.instance().service('DeleteFlowAction', DeleteFlowAction);
